




















import Vue from 'vue';

export default Vue.extend({
    data: () => ({
        isFirefox: navigator && navigator.userAgent && /firefox/i.test(navigator.userAgent),
    }),
});
